var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplaySmallCustomGifts = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.607 15.956v8.841c0 .818.658 1.477 1.477 1.477h7.364V15.956H4.607z",
    fill: "#9A5238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.244 10.068h-4.67c.339-.22.618-.46.818-.659a3.06 3.06 0 0 0 0-4.33c-1.158-1.158-3.174-1.158-4.331 0-.639.638-2.335 3.252-2.096 4.989h-.1c.24-1.737-1.457-4.351-2.095-4.99-1.158-1.157-3.174-1.157-4.331 0a3.06 3.06 0 0 0 0 4.331c.2.2.499.44.818.659h-4.67c-.819 0-1.477.658-1.477 1.477v2.215c0 .4.34.739.738.739h9.58v-2.954h2.954v2.954h9.58c.4 0 .739-.34.739-.739v-2.215a1.444 1.444 0 0 0-1.457-1.477zm-11.876-.06s-.06.04-.279.04c-1.018 0-2.954-1.058-3.593-1.697a1.602 1.602 0 0 1 0-2.255c.3-.3.699-.459 1.118-.459.42 0 .818.16 1.118.46.978 1.017 1.976 3.572 1.636 3.91zm3.393.06c-.2 0-.28-.04-.28-.04-.338-.36.64-2.914 1.638-3.912.598-.599 1.636-.599 2.235 0a1.602 1.602 0 0 1 0 2.255c-.639.639-2.575 1.697-3.593 1.697z",
    fill: "#1E2969"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.402 15.956v10.318h7.365c.818 0 1.477-.659 1.477-1.477v-8.841h-8.842z",
    fill: "#9A5238"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplaySmallCustomGifts);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-small-custom-gifts.353c9e0bd26591a0cc27ff49fe8d21da.svg";